/** Share %: up to 4 decimal places, no trailing zeros when whole. */
export function formatPercent(value) {
    if (value === null || value === undefined || value === '') return '';
    const n = Number(String(value).replace(',', '.').replace(/%/g, '').trim());
    if (!Number.isFinite(n)) return String(value);
    return n.toFixed(4).replace(/\.?0+$/, '');
}

/** Number for forms / InputNumber (strips DECIMAL trailing zeros). */
export function parsePercent(value, fallback = 100) {
    if (value === null || value === undefined || value === '') return fallback;
    const n = Number(String(value).replace(',', '.').replace(/%/g, '').trim());
    if (!Number.isFinite(n)) return fallback;
    return Number(n.toFixed(4).replace(/\.?0+$/, ''));
}

function formatPercentInputDisplay(value, withSuffix) {
    if (value === undefined || value === null || value === '') return '';
    const raw = String(value);
    // Keep in-progress typing (trailing separator)
    if (/[.,]$/.test(raw.replace(/%/g, '').trim())) {
        const body = raw.replace(/%/g, '').replace('.', ',');
        return withSuffix ? `${body}%` : body;
    }
    const formatted = formatPercent(raw);
    if (!formatted && formatted !== '0') return withSuffix ? '%' : '';
    return withSuffix ? `${formatted.replace('.', ',')}%` : formatted.replace('.', ',');
}

/** Ant Design InputNumber props for share %. */
export const percentInputNumberProps = {
    min: 0,
    step: 0.0001,
    decimalSeparator: ',',
    // Prevent rc-input-number from padding to step precision when formatter runs
    formatter: (value, info) => {
        if (info?.userTyping) return info.input;
        return formatPercentInputDisplay(value, false);
    },
    parser: (value) =>
        String(value ?? '')
            .replace(/%/g, '')
            .replace(/\s/g, '')
            .replace(',', '.'),
};

/** Same as percentInputNumberProps, with trailing % in the field. */
export const percentInputNumberWithSuffixProps = {
    ...percentInputNumberProps,
    formatter: (value, info) => {
        if (info?.userTyping) return info.input;
        return formatPercentInputDisplay(value, true);
    },
};
